export enum GaContactType {
  Email = 'email',
  Telefon = 'telefon',
}
